export const UserUpdatePassword = {
	'Update your new password': 'Update your new password',
	'You will receive in your email all the instructions to recover your password.':
		'You will receive all the instructions to recover your password in your email.',
	Password: 'Password',
	'Confirm your password': 'Confirm your password',
	'Recover password': 'Recover password',
	'Enter document number or email': 'Enter your document number or email',
	'Back to home': 'Back to home',
	'Reset Code': 'Reset code',
	'Updating...': 'Updating...',
};
